import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postShelfs({ body }) {
  return BaseService.post(REST.SHELFS, body);
}

function putShelfs({ body, id }) {
  return BaseService.put(REST.SHELFS_ID(id), body);
}

function getShelfs(params) {
  return BaseService.get(REST.SHELFS, {
    params: paramsFilter({ params }),
  });
}

function deleteShelfs({ id }) {
  return BaseService.delete(REST.SHELFS_ID(id));
}

export default {
  getShelfs,
  deleteShelfs,
  postShelfs,
  putShelfs,
};
